import { IconName } from '@frontend/icons';
import { QuickFilterCards } from './quick-filter-cards';
import { QuickFilterDropdown } from './quick-filter-dropdown';

export enum QuickFilterKey {
  All = 'all',
  Unconfirmed = 'unconfirmed',
  Insurance = 'insurance',
}

export type ListItem = {
  key: QuickFilterKey;
  label: string;
  count: number;
  iconName: IconName;
  trackingId?: string;
};

type Props = {
  variant?: 'dropdown' | 'card';
  list: ListItem[];
  onSelectHandler: (filter: QuickFilterKey) => void;
};

export const QuickFilters = ({ variant = 'card', list, onSelectHandler }: Props) => {
  if (variant === 'dropdown') {
    return <QuickFilterDropdown list={list} onSelect={onSelectHandler} />;
  }

  return <QuickFilterCards list={list} onClick={onSelectHandler} />;
};
